/**
 * Allowed AI agent actions (allowlist — no arbitrary shell/SQL).
 */

export const AGENT_ACTION_TYPES = {
  READ_ONLY: 'read_only',
  CREATE_CLIENT: 'create_client',
  CREATE_PRODUCT: 'create_product',
  CREATE_INVOICE: 'create_invoice',
  UPDATE_STOCK: 'update_stock',
  SEND_REMINDER: 'send_reminder',
  SEARCH: 'search',
  ANALYZE: 'analyze',
};

/** Actions that mutate ERP data — require user confirmation */
export const AGENT_ACTIONS_REQUIRING_CONFIRMATION = new Set([
  AGENT_ACTION_TYPES.CREATE_CLIENT,
  AGENT_ACTION_TYPES.CREATE_PRODUCT,
  AGENT_ACTION_TYPES.CREATE_INVOICE,
  AGENT_ACTION_TYPES.UPDATE_STOCK,
]);

export const AGENT_LOCAL_API_PATHS = {
  create_invoice: '/facturation/archives',
  create_client: '/facturation/clients',
  create_product: '/facturation/products',
};
